import { FC, ReactNode } from 'react'

interface SlideProps {
  children?: ReactNode
}
export const Slide: FC<SlideProps> = ({ children }) => {
  return <div className={'min-w-full min-h-full'}>{children}</div>
}
